import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { modules } from '../data/content';
export function Modules() {
  return <section className="bg-cream px-4 py-6 sm:px-6" data-id="element-103" data-mp="1r4sov7zfhav5">
      <div className="mx-auto max-w-2xl" data-id="element-104" data-mp="1vxc3875xwa10">
        <h2 className="text-center font-heading text-xl font-extrabold uppercase text-petrol sm:text-3xl" data-id="element-105" data-mp="1vydgmiafh8lw">
          What’s included
        </h2>
        <div className="mt-4 space-y-3" data-id="element-106" data-mp="145w81oqbhez6">
          {modules.map(mod => <article key={mod.number} className="overflow-hidden rounded-xl border border-petrol/15 bg-white shadow-sm" data-id="element-107" data-mp="147z7t0h9umh3">
              <div className="flex items-center gap-2 bg-petrol px-3 py-2" data-id="element-108" data-mp="1d5jc6iafkyvx">
                <CheckCircle2Icon className="h-4 w-4 shrink-0 text-sage" strokeWidth={2.5} data-id="element-109" data-mp="1i66zotzgaxle" />
                <h3 className="font-heading text-[0.8rem] font-extrabold uppercase leading-tight text-white sm:text-base" data-id="element-110" data-mp="2olhnytwztz0u">
                  Module {mod.number} — {mod.title}
                </h3>
              </div>
              <div className="px-3 py-3" data-id="element-111" data-mp="1sys8z7z4r1u">
                <p className="text-sm leading-snug sm:text-base" data-id="element-112" data-mp="3tylxfj9q41iw">{mod.body}</p>
                <p className="mt-1.5 font-heading text-xs font-bold uppercase tracking-wide text-sage sm:text-sm" data-id="element-113" data-mp="3ozirlwlx5r9v">
                  {mod.steps}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}